import { useEffect } from 'react';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import Solution from './components/Solution';
import Features from './components/Features';
import Architecture from './components/Architecture';
import AIRoadmap from './components/AIRoadmap';
import TargetAudience from './components/TargetAudience';
import CTA from './components/CTA';
// @ts-ignore
import { useAutoSEO } from '../../hooks/useSEOFromRoute';

const StackWaySkillHubPage = () => {
  // Auto fetch SEO from database based on route
  useAutoSEO();

  // Override header styles for Skill Hub page - only text colors, not background
  useEffect(() => {
    // Add custom class to body for Skill Hub page styling
    document.body.classList.add('skill-hub-page');
    
    // Add custom styles for header text colors
    const style = document.createElement('style');
    style.id = 'skill-hub-header-override';
    style.innerHTML = `
      /* Keep text always dark colored on Skill Hub page */
      .skill-hub-page header > div > div > a > span[class*="text-white"] {
        color: #2a4b7c !important;
      }
      .skill-hub-page header > div > div > nav > div > a[class*="text-white"] {
        color: #333 !important;
      }
      .skill-hub-page header > div > div > a[href="/lien-he"][class*="bg-white"] {
        background: #00c897 !important;
        color: white !important;
      }
      .skill-hub-page header > div > div > button[class*="text-white"] {
        color: #333 !important;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.body.classList.remove('skill-hub-page');
      const styleElement = document.getElementById('skill-hub-header-override');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-inter">
      <Hero />
      <PainPoints />
      <Solution />
      <Features />
      <Architecture />
      <AIRoadmap />
      <TargetAudience />
      <CTA />
    </div>
  );
};

export default StackWaySkillHubPage;
